/**
 * Platform IDs returned by `detectPlatform()`.
 *
 * Each ID corresponds to a single Reader installer target. Consumers
 * map IDs to their own (label, logo, install URL) configuration —
 * the library does not own the install metadata.
 *
 * Frozen so accidental writes throw in strict mode.
 */
export const PLATFORMS = Object.freeze({
    /** Windows 10 / 11 — install via Microsoft Store. */
    MICROSOFT_STORE: 'microsoft-store',

    /** Legacy Windows 7 / 8 / 8.1 — install via direct .msi download. */
    WINDOWS_MSI: 'windows-msi',

    /** macOS on Apple Silicon (M-series). */
    MACOS_ARM: 'macos-arm',

    /** macOS on Intel. */
    MACOS_INTEL: 'macos-intel',

    /** iPhone / iPad (including iPadOS 13+ which reports as Macintosh). */
    IOS: 'ios',

    /** Android (excluding Huawei AppGallery devices and ChromeOS). */
    ANDROID: 'android',

    /** Huawei devices without Google Play Services — install via AppGallery. */
    HUAWEI: 'huawei',

    /**
     * No rule matched. Consumers should treat this as "no native recommendation"
     * and fall back to showing all available installers.
     */
    UNKNOWN: 'unknown',
});
